<script lang="ts">
	import { onMount } from 'svelte';
	import { fade } from 'svelte/transition';
	import Input from '../ui/input/input.svelte';
	import Button from '../ui/button/button.svelte';
	import Label from '../ui/label/label.svelte';
	import { ArrowRight, CheckCircle, Loader2 } from 'lucide-svelte';

	let email = $state('');
	let loading = $state(false);
	let success = $state(false);
	let error = $state('');

	onMount(() => {
		const form = document.querySelector('form');
		form.addEventListener('submit', handleSubmit);
	});

	function resetForm() {
		if (success) {
			success = false;
			email = '';
			error = '';
		}
	}

	async function handleSubmit(event) {
		event.preventDefault();
		loading = true;
		error = '';

		try {
			const response = await fetch('https://formspree.io/f/mwpkengg', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ email })
			});

			if (response.ok) {
				success = true;
				email = '';
			} else {
				throw new Error('Submission failed');
			}
		} catch (err) {
			error = 'An error occurred. Please try again.';
		} finally {
			loading = false;
		}
	}
</script>

<form class="mx-auto mb-10 w-full max-w-md">
	<Label
		for="email"
		class="mb-4 flex w-full items-center justify-center text-center font-heading text-xl font-semibold lg:text-2xl"
		>Join our mailing list</Label
	>
	<div class="relative mt-2 flex w-full items-center justify-center">
		<div class="flex-grow">
			<Input
				placeholder="Enter your email"
				type="email"
				id="email"
				name="email"
				bind:value={email}
				required
				class="h-12 w-full rounded-full pl-4 pr-4 text-gray-700 focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0"
				on:focus={resetForm}
			/>
		</div>

		<Button
			type="submit"
			size="icon"
			class="{success
				? 'bg-[#194139] hover:bg-green-600'
				: 'bg-[#194139] hover:bg-[#194139]/80'} absolute right-2 flex items-center justify-center rounded-full font-bold text-white transition duration-300 ease-in-out"
			disabled={loading || success}
		>
			{#if loading}
				<Loader2 class="h-5 w-5 animate-spin" />
			{:else if success}
				<CheckCircle class="h-5 w-5" />
			{:else}
				<ArrowRight class="h-5 w-5" />
			{/if}
		</Button>
	</div>

	{#if error}
		<p transition:fade class="mt-4 text-center text-red-600">{error}</p>
	{/if}
</form>
